export const JdbcDriverType = {
    'GENERIC': 'generic',
    'MY_SQL': 'mySQL',
    'POSTGRESS': 'postgreSQL',
    'ORACLE': 'oracle',
    'MS_SQL': 'msSQL',
    'DB2': 'DB2',
    'DREMIO': 'dremio',
    'DATABRICKS': 'databricks',
    'SNOWFLAKE': 'snowflake'
};
